// Authentication state management
export const AUTH_STORAGE_KEY = 'rt-auth-token';
export const USER_STORAGE_KEY = 'rt-user-profile';

// Store authentication token
export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_STORAGE_KEY, token);
};

// Get authentication token
export const getAuthToken = () => {
  return localStorage.getItem(AUTH_STORAGE_KEY);
};

// Remove authentication token and all stored auth data
export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  // Clear the legacy credential cache left by releases before the secure-keys endpoint was removed.
  localStorage.removeItem('rt-secure-keys');
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem('rt-free-tier-info');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getAuthToken();
  return token !== null && token !== undefined;
};

// Store user profile
export const storeUser = (user) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

// Get stored user profile
export const getUser = () => {
  try {
    const user = localStorage.getItem(USER_STORAGE_KEY);
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error retrieving user profile:', error);
    return null;
  }
};
